import {
  createBundleBasicFormStepFormValidationSchema,
  CreateBundleBasicFormStepFormValues,
} from "../../createBundle/multi-step/basic-form/schema-validation";
import {SessionSettingsFormFieldsType} from "../../../../components/offering-form/session-bundle/session/settings/types";
import {CoverImagesItemResponse} from "../../../../react-query-hooks/products/types";
import yup from "../../../../utils/yup-extended";
export const editBundleBasicFormStepFormValidationSchema =
  createBundleBasicFormStepFormValidationSchema.shape({
    isPaused: yup.bool().default(false),
    cover_images: yup
      .array()
      .default([])
      .max(5, "You can only add a maximum of 5 images"),
  });

export type EditBundleBasicFormStepFormValuesYup = yup.InferType<
  typeof editBundleBasicFormStepFormValidationSchema
>;

export type EditBundleBasicFormStepFormValues = CreateBundleBasicFormStepFormValues &
  SessionSettingsFormFieldsType & {
    cover_images: CoverImagesItemResponse[];
  };
